import { Row, Col } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import add from "../../images/add.png";
import MultiImageInput from "react-multiple-image-input";

import { CompactPicker } from "react-color";
import { ToastContainer } from "react-toastify";
import AdminAddProductsHook from "./../../hook/products/add-products-hook";
import DescriptionForm from "./DescriptionForm";
import DisableButton from "../Uitily/DisableButton";

const AdminAddProducts = () => {
  const [
    onChangeQty,
    onChangeColor,
    onChangePriceAfter,
    onChangePriceBefor,
    onChangeProdName,
    showColor,
    category,
    brand,
    priceAftr,
    images,
    setImages,
    onSelect,
    onRemove,
    options,
    handelChangeComplete,
    removeColor,
    onSeletCategory,
    handelSubmit,
    onSeletBrand,
    colors,
    priceBefore,
    qty,
    prodName,
    img,
    onImageChange,
    description,
    onChangeDesName,
    addRow,
    removeRow,
    checkIsComplate,
  ] = AdminAddProductsHook();

  return (
    <div>
      <Row className="justify-content-start ">
        <div className="admin-content-text pb-4"> اضافه منتج جديد</div>
        <Col sm="8">
          <div className="text-form pb-2"> صور للمنتج</div>

          {/* <MultiImageInput
                        images={images}
                        setImages={setImages}
                        theme={"light"}
                        allowCrop={false}
                        max={4}
                    /> */}
          <div>
            <label for="upload-photo">
              <img
                src={img}
                alt="fzx"
                height="100px"
                width="120px"
                style={{ cursor: "pointer" }}
              />
            </label>
            <input
              type="file"
              name="photo"
              onChange={onImageChange}
              id="upload-photo"
            />
          </div>
          <input
            value={prodName}
            onChange={onChangeProdName}
            type="text"
            className="input-form d-block mt-3 px-3"
            placeholder="اسم المنتج"
          />
          {/* <textarea
            className="input-form-area p-2 mt-3"
            rows="4"
            cols="50"
            placeholder="وصف المنتج"
            value={prodDescription}
            onChange={onChangeDesName}
          /> */}
          <div className="mt-4">
            {description
              ? description.map((item, index) => (
                  <div key={index} className="d-flex my-2">
                    <input
                      type="text"
                      className="form-control"
                      value={item.key}
                      onChange={(e) =>
                        onChangeDesName(index, "key", e.target.value)
                      }
                      placeholder="الوصف"
                      required
                    />
                    <input
                      type="text"
                      className="form-control mx-3"
                      value={item.value}
                      onChange={(e) =>
                        onChangeDesName(index, "value", e.target.value)
                      }
                      placeholder="القيمه"
                      required
                    />
                    <button
                      className="btn btn-danger"
                      onClick={() => removeRow(index)}
                      disabled={description.length === 1}
                    >
                      <i class="fa fa-light fa-circle-minus"></i>
                    </button>
                  </div>
                ))
              : null}
          </div>
          <div className="d-flex align-items-center justify-content-between my-3">
            <button className="btn btn-success" onClick={addRow}>
              <i class="fa fa-light fa-circle-plus"></i>
            </button>
          </div>
          <div className="d-flex">
            <input
              min={1}
              type="number"
              className="input-form d-block px-3"
              placeholder="السعر قبل الخصم"
              value={priceBefore > 0 ? priceBefore : null}
              onChange={onChangePriceBefor}
            />
            <input
              min={1}
              type="number"
              className="input-form d-block mx-3 px-3"
              placeholder="السعر بعد الخصم"
              value={priceAftr > 0 ? priceAftr : null}
              onChange={onChangePriceAfter}
            />
            <input
              type="number"
              className="input-form d-block x-3"
              placeholder="الكمية المتاحة"
              value={qty}
              onChange={onChangeQty}
            />
          </div>
          <select
            name="cat"
            onChange={onSeletCategory}
            className="select input-form-area mt-3 px-2 "
          >
            <option value="0">التصنيف الرئيسي</option>
            {category && category.data && category && category.data.length > 1
              ? category.data.map((item, index) => {
                  return (
                    <option key={index} value={item._id}>
                      {item.name}
                    </option>
                  );
                })
              : null}
          </select>

          <Multiselect
            className="mt-2 text-end"
            placeholder="التصنيف الفرعي"
            options={options}
            onSelect={onSelect}
            onRemove={onRemove}
            displayValue="name"
            style={{ color: "red" }}
          />
          <select
            name="brand"
            onChange={onSeletBrand}
            className="select input-form-area mt-3 px-2 "
          >
            <option value="0">اختر ماركة</option>
            {brand && brand.data && brand.data.length > 1
              ? brand.data.map((item, index) => {
                  return (
                    <option key={index} value={item._id}>
                      {item.name}
                    </option>
                  );
                })
              : null}
          </select>
          <div className="text-form mt-3 "> الالوان المتاحه للمنتج</div>
          <div className="mt-1 d-flex">
            {colors.length >= 1
              ? colors.map((color, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => removeColor(color)}
                      className="color ms-2 border  mt-1"
                      style={{ backgroundColor: color }}
                    ></div>
                  );
                })
              : null}

            <img
              onClick={onChangeColor}
              src={add}
              alt=""
              width="30px"
              height="35px"
              style={{ cursor: "pointer" }}
            />
            {showColor === true ? (
              <CompactPicker onChangeComplete={handelChangeComplete} />
            ) : null}
          </div>
        </Col>
      </Row>
      <Row>
        <Col sm="8" className="d-flex justify-content-end ">
          {checkIsComplate() ? (
            <button onClick={handelSubmit} className="btn-save d-inline mt-2 ">
              حفظ التعديلات
            </button>
          ) : (
            <DisableButton />
          )}
        </Col>
      </Row>
      <ToastContainer />
    </div>
  );
};

export default AdminAddProducts;
